module.exports = __webpack_public_path__ + "static/media/feature-stylish-logo1.78902a01.png";